/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { DropDown2, Input2 } from "components";
import { useInput } from "hooks";
import { ALL_COUPON_TYPES_PREDICTIVE_TEXT } from "config";

export const OfferPurchaseProductTextBuilder = ({
  className,
  value,
  onChange = () => {},
}) => {
  const withPurchase = useInput("");
  const withCoupon = useInput("");

  const handleUpdateValue = (products, withCpn) => {
    onChange(`w/purchase/${products}${withCpn ? " w/" + withCpn : ""}`);
  };

  useEffect(() => {
    if (value && value.startsWith("w/purchase/")) {
      // remove "w/purchase/"
      let text = value.replace("w/purchase/", "").trim();

      // check if coupon exists
      if (text.includes("w/")) {
        let parts = text.split("w/");
        withPurchase.setValue(parts[0].trim());
        withCoupon.setValue(parts[1].trim());
      } else {
        withPurchase.setValue(text);
        withCoupon.setValue("");
      }
    }
    return () => { };
  }, [value]);

  return (
    <div className={`${className} mt-1 p-2`}>
      <Title>Offer Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-1">w/purchase/</div>
        <div style={{ width: 200, marginLeft: 10 }}>
          <Input2
            placeholder="Product(s)"
            value={withPurchase.value}
            onChange={(e) => {
              withPurchase.setValue(e);
              handleUpdateValue(e, withCoupon.value);
            }}
          />
        </div>
      </Container>

      <Container className="mt-2">
        <div className="mt-auto mb-1">w/coupon</div>
        <div style={{ width: 200, marginLeft: 10 }}>
          <DropDown2
            data={ALL_COUPON_TYPES_PREDICTIVE_TEXT}
            width={80}
            value={withCoupon.value}
            onChange={(e) => {
              withCoupon.setValue(e);
              handleUpdateValue(withPurchase.value, e);
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
